import jsPDF from "jspdf";
import { font } from './font.js';
//import { callAddFont } from './callAddFont.js';



const testFontInPDF = async () => {
    console.log("Testing the Arabic font...");

    const pdf = new jsPDF();

    // Register the font
    pdf.addFileToVFS("Amiri-Regular-normal.ttf", font);
    pdf.addFont("Amiri-Regular-normal.ttf", "Amiri-Regular", "normal");

    // Set the font and write a test string
    pdf.setFont("Amiri-Regular");
    pdf.setFontSize(16);
    //pdf.text("اختبار الخط العربي", 10, 20, { align: "right" }); // Test Arabic text

    console.log("Arabic font tested successfully. It appears to be working correctly.");

    // Optionally save the test PDF for manual verification
    //pdf.save("font-test.pdf");

    // Return the prepared jsPDF instance for further use
    return { pdf, font };
};


export const handleExportToPDFArabic = async (messages, t, i18n) => {
    console.log("Starting PDF export...");

    if (!messages || messages.length === 0) {
        console.error("No messages to export");
        return;
    }

    const preprocessTextForArabic = (text) => {
        // Helper function to split text into parts inside and outside brackets
        const splitByBrackets = (text) => {
            const parts = [];
            let current = '';
            let inBrackets = false;

            for (let char of text) {
                if (char === '[' || char === '(') {
                    if (current) parts.push({ text: current, inBrackets: false });
                    current = char;
                    inBrackets = true;
                } else if (char === ']' || char === ')') {
                    current += char;
                    parts.push({ text: current, inBrackets: true });
                    current = '';
                    inBrackets = false;
                } else {
                    current += char;
                }
            }
            if (current) parts.push({ text: current, inBrackets });
            return parts;
        };

        const processedParts = splitByBrackets(text).map(part => {
            if (part.inBrackets) {
                return part.text; // Preserve text inside brackets
            } else {
                // Apply "match sequences" rules only outside brackets
                return part.text
                    .replace(/([0-9]+[0-9\s.:/?&=_\-\[\]()]*[0-9]+)/g, "\n$1\n")
                    .replace(/([A-Za-z]+[A-Za-z\s.:/?&=_\-\[\]()]*[A-Za-z]+)/g, "\n$1\n");
            }
        });

        return processedParts
            .join('')
            // Add newlines around brackets
            .replace(/\[/g, "\n[")
            .replace(/\]/g, "]\n")
            .replace(/\(/g, "\n(")
            .replace(/\)/g, ")\n")
            // Shift numeric itemization (e.g., "1.") to the beginning of the line
            .replace(/(\s)(\d+\.)/g, "\n$2")
            .replace(/(\.\d+)\s*$/gm, "\n$1")
            .trim();
    };




    try {
        const { pdf } = await testFontInPDF();

        console.log("Processing messages...");
        const isRTL = i18n?.language === "arabic"; // Check if Arabic is active
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margins = { horizontal: 15, vertical: 20 };
        const lineHeight = 8;
        let yOffset = margins.vertical;

        for (let i = 3; i < messages.length; i++) {
            const { type, text } = messages[i];
            console.log(`Processing message ${i} of type "${type}"`);

            // Preprocess and clean text
            const cleanedText = preprocessTextForArabic(text.replace(/[`*]/g, ""));
            console.log("Cleaned and formatted text for Arabic:", cleanedText);

            // Add a new page if needed
            if (yOffset + lineHeight > pageHeight - margins.vertical) {
                console.log("Adding a new page...");
                pdf.addPage();
                yOffset = margins.vertical;
            }

            // Add message type
            const header = type === "user" ? t("chat.export_user") : t("chat.export_assistant");
            pdf.text(`${isRTL ? header + " :" : header + ":"}`,
                isRTL ? pageWidth - margins.horizontal : margins.horizontal,
                yOffset,
                { align: isRTL ? "right" : "left" }
            );
            yOffset += lineHeight;

            // Split text into lines and add to PDF
            const lines = pdf.splitTextToSize(cleanedText, pageWidth - margins.horizontal * 2);
            lines.forEach((line) => {
                if (yOffset + lineHeight > pageHeight - margins.vertical) {
                    console.log("Adding a new page for wrapped text...");
                    pdf.addPage();
                    yOffset = margins.vertical;
                }

                pdf.text(line, isRTL ? pageWidth - margins.horizontal : margins.horizontal, yOffset, {
                    align: isRTL ? "right" : "left",
                });
                yOffset += lineHeight;
            });

            // Draw separator line
            pdf.line(margins.horizontal, yOffset, pageWidth - margins.horizontal, yOffset);
            yOffset += lineHeight;
        }

        const timestamp = new Date().toISOString().split("T")[0];
        pdf.save(`IJsselAssist-chat-history-${timestamp}.pdf`);
        console.log("PDF export completed successfully!");
    } catch (error) {
        console.error("PDF export failed:", error);
    }
};
